import { instanceToPlain } from 'class-transformer';
import { ZeroAddress, isAddress } from 'ethers';
import { pathToRegexp } from 'path-to-regexp';
import { formatUnits } from 'viem';

export const unreachable = (): never => {
  throw Error('unreachable method called');
};

export function makePath(path: string): RegExp {
  return pathToRegexp(path).regexp;
}

export function matchPath(pathname: string, pattern: RegExp): boolean {
  return pattern.test(pathname);
}

export function truncateHex(address: string, length = 4, isGala?: boolean): string {
  if (!isAddress(address) && !isGala) {
    if (length === 0) {
      return ZeroAddress;
    }

    return '0x000...0000';
  }

  return `${address.slice(0, length + 2)}...${address.slice(-length)}`;
}

export function toNormalizedValue(v: bigint, d?: number): number {
  return Number(formatUnits(v, d ?? 18));
}

export function getPayloadToSign(obj: object): string {
  const { signature, trace, ...plain } = instanceToPlain(obj);
  return JSON.stringify(instanceToPlain(plain));
}

export function upperFirstCharacterOfString(str: string) {
  if (!str) return;
  const lowerStr = str.toLowerCase();
  return lowerStr.charAt(0).toUpperCase() + lowerStr.slice(1);
}

export function upperAllFirstCharacterOfString(str: string) {
  if (!str) return '';
  return str
    .split(' ')
    .map(word => upperFirstCharacterOfString(word))
    .join(' ');
}

export function formatHex(value: string): `0x${string}` {
  if (value.startsWith('0x')) return value as `0x${string}`;
  return `0x${value}`;
}
